<template>
  <hic-patient-dialog :id="patientCode" :visible="visible" is-editor hide-health one-contact hide-other title="入院登记" @open="open" @close="close" @loaded="patientLoaded" @saved="patientSaved" @canceled="close">
    <el-form class="left" ref="editor" :rules="rules" :inline="true" :model="submitInfo" label-width="8rem">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患者来自：">
            {{ submitInfo.comeFrom | dictText("IpComeFrom") }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="门诊科室：">
            {{ submitInfo.opDeptCode | dictText("Dept") }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="门诊医师：">
            {{ submitInfo.opDoctorName }}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入院次数："> 第 {{ submitInfo.stayTimes }} 次住院 </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="门诊诊断：">
            <ul style="margin: 0; padding: 0 0 0 10px;">
              <li v-for="d in diagnoses" :key="d.id">
                <span>{{ d.type }}：</span>
                <b>{{ d.name }}</b>
                <small>（{{ d.code }}）</small>
                <b v-if="d.symptomName">{{ d.symptomName }}</b>
                <small v-if="d.symptomCode">（{{ d.symptomCode }}）</small>
              </li>
            </ul>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="住院类型：">
            <hic-dict-selector dict-type="IpStayType" v-model="submitInfo.stayType" placeholder="请选择住院类型" class="edit-input"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入院科室：" prop="originalDeptCode">
            <hic-dict-selector dict-type="Dept" v-model="submitInfo.originalDeptCode" placeholder="请选择入院科室" class="edit-input"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入院病区：" prop="originalWardCode">
            <hic-dict-selector dict-type="IpWard" v-model="submitInfo.originalWardCode" placeholder="请选择入院病区" class="edit-input"></hic-dict-selector>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="费用类型：">
            <el-radio-group v-model="submitInfo.ipType">
              <el-radio v-for="t in Enum.IpType" :key="t" :label="t" size="mini">{{ t.substring(t.length - 2) }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="submitInfo.ipType != '自费'" :span="8">
          <el-form-item label="医保类型：">
            {{ submitInfo.insuranceType | dictText("InsuranceType") }}
          </el-form-item>
        </el-col>
        <el-col v-if="submitInfo.ipType != '自费'" :span="8">
          <el-form-item label="医保卡号：" prop="insuranceNo">
            {{ submitInfo.insuranceNo }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </hic-patient-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
      visible: Boolean,
    },
    data() {
      return {
        submitInfo: {},
        patientCode: null,
        rules: {
          originalDeptCode: [{ required: true, message: "请选择科室编码", trigger: "change" }],
          originalWardCode: [{ required: true, message: "请选择入院病区", trigger: "change" }],
          insuranceType: [{ required: true, message: "请选择医疗付费方式", trigger: "change" }],
        },
        diagnoses: [],
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "user"]),
    },
    methods: {
      open() {
        this.patientCode = null;
        this.$nextTick(() => {
          this.patientCode = this.value.patientCode;
          this.submitInfo = { ipType: "" };
          this.$utils.Obj.propertyCopy(this.value, this.submitInfo); //为了使用raido能够正常使用，需要重置数据的值
        });
        if (this.value && this.value.opNo) {
          api.Diagnosis.query({ scope: "门诊", mainNo: this.value.opNo }).then((res) => {
            this.diagnoses = res.items;
          });
        }
      },
      close() {
        this.$emit("update:visible", false);
      },
      patientLoaded(patient) {
        this.submitInfo.patientCode = patient.id;
        this.submitInfo.patientName = patient.name;
        this.submitInfo.patientGender = patient.gender;
        this.submitInfo.patientAge = this.$utils.Fmt.age(patient.birthday);
        this.submitInfo.insuranceType = patient.insuranceType;
        this.submitInfo.insuranceNo = patient.insuranceNo;
        if (!this.submitInfo.ipType && patient.insuranceNo) {
          this.submitInfo.ipType = this.Enum.IpType.医保;
        } else {
          this.submitInfo.ipType = this.Enum.IpType.自费;
        }
      },
      patientSaved(patient) {        
        this.patientLoaded(patient);
        api.Hospitalization.save(this.submitInfo)
          .then((res) => {
            this.$emit("saved", res);
            this.$message.success("入院登记保存成功！");
            this.$emit("update:visible", false);
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
    },
  };
</script>
